<template>
  <v-app>
    <dashboard-core-app-bar target="#about-me" />

    <dashboard-core-drawer />

    <dashboard-core-view />
    <v-btn  id="scrollTop" fab class="primary float" @click="scrollTop"><v-icon>mdi-chevron-up </v-icon></v-btn>
    <!-- <dashboard-core-settings /> -->
  </v-app>
</template>

<script>
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },
    methods: {
     onScroll (e) {
      return e.target.scrollTop
    },
      scrollTop(){
        this.$vuetify.goTo(0);
      }
    },
    data: () => ({
      expandOnHover: false,
    }),
  }
</script>
<style>
.float{
	position:fixed;
	width:60px;
	height:60px;
	bottom:40px;
	left:40px;
}
</style>
